import { Navbar, Nav, Container } from "react-bootstrap";
import { NavLink, useLocation, useNavigate } from "react-router-dom";
import { useState, useEffect } from "react";
import TimeRegistryLogo from "./TimeRegistryLogo";

export default function AppNavbar() {
  const location = useLocation();
  const navigate = useNavigate();
  const [isLoggedIn, setIsLoggedIn] = useState(!!localStorage.getItem("token"));
  const [logoHeight, setLogoHeight] = useState(70);
  
  useEffect(() => {
    const updateLogoHeight = () => {
      setLogoHeight(window.innerWidth <= 768 ? 50 : 70);
    };
    updateLogoHeight();
    window.addEventListener('resize', updateLogoHeight);
    return () => window.removeEventListener('resize', updateLogoHeight);
  }, []);

  useEffect(() => {
    setIsLoggedIn(!!localStorage.getItem("token"));
  }, [location]);

  const handleLogout = () => {
    localStorage.removeItem("token");
    setIsLoggedIn(false);
    navigate("/login");
  };

  return (
    <Navbar sticky="top" expand="lg" className="brutal-navbar">
      <Container className="p-0" fluid>
        {/* Brand */}
        <Navbar.Brand as={NavLink} to="/" className="brutal-brand">
          <TimeRegistryLogo height={logoHeight} />
        </Navbar.Brand>

        <Navbar.Toggle className="brutal-toggle" />

        <Navbar.Collapse>
          <Nav className="ms-auto gap-3 align-items-center">
            {isLoggedIn && (
              <>
                <Nav.Link as={NavLink} to="/registry" className="brutal-nav-link">
                  REGISTRY
                </Nav.Link>

                <Nav.Link as={NavLink} to="/buy" className="brutal-nav-link">
                  BUY
                </Nav.Link>

                <Nav.Link as={NavLink} to="/profile" className="brutal-nav-link">
                  PROFILE
                </Nav.Link>

                <Nav.Link
                  onClick={handleLogout}
                  className="brutal-nav-link brutal-nav-link-danger"
                  style={{ cursor: "pointer" }}
                >
                  LOGOUT
                </Nav.Link>
              </>
            )}

            {!isLoggedIn && (
              <Nav.Link as={NavLink} to="/login" className="brutal-nav-link">
                LOGIN
              </Nav.Link>
            )}
          </Nav>
        </Navbar.Collapse>
      </Container>
      <style>{`
        .brutal-navbar {
          background: #FFFFFF !important;
          border-bottom: 6px solid #000000 !important;
          box-shadow: 0 4px 0px #000000;
          padding: 0 !important;
          min-height: 80px;
        }
        .brutal-navbar .navbar-brand {
          padding: 0 !important;
          margin: 0 !important;
        }
        .brutal-brand {
          font-weight: 900;
          text-transform: uppercase;
          letter-spacing: 2px;
          padding: 0 !important;
          margin: 0 !important;
          margin-left: -15px !important;
          display: flex;
          align-items: center;
        }
        .brutal-navbar .container-fluid {
          padding-left: 15px !important;
          padding-right: 15px !important;
        }
        .brutal-toggle {
          border: 4px solid #000000 !important;
          border-radius: 0 !important;
          min-width: 44px;
          min-height: 44px;
          padding: 8px !important;
        }
        @media (max-width: 768px) {
          .brutal-brand {
            margin-left: 0 !important;
          }
          .brutal-navbar .container-fluid {
            padding-left: 10px !important;
            padding-right: 10px !important;
          }
          .brutal-navbar {
            min-height: 70px;
          }
          .brutal-nav-link {
            padding: 12px 16px !important;
            min-height: 44px;
            display: flex;
            align-items: center;
            width: 100%;
            justify-content: flex-start;
            font-size: 14px;
            letter-spacing: 1.5px;
          }
          .brutal-navbar .navbar-collapse {
            border-top: 3px solid #000000;
            margin-top: 10px;
            padding-top: 10px;
          }
          .brutal-navbar .navbar-nav {
            width: 100%;
          }
          .brutal-navbar .navbar-nav .nav-link {
            width: 100%;
          }
          .brutal-toggle {
            border-width: 3px;
            padding: 6px !important;
          }
          .brutal-toggle:focus {
            box-shadow: 3px 3px 0px #000000;
          }
        }
        
        @media (max-width: 575px) {
          .brutal-navbar {
            min-height: 60px;
          }
          .brutal-nav-link {
            font-size: 12px;
            padding: 10px 14px !important;
            letter-spacing: 1px;
          }
          .brutal-navbar .container-fluid {
            padding-left: 8px !important;
            padding-right: 8px !important;
          }
        }
        .brutal-nav-link {
          font-weight: 900 !important;
          text-transform: uppercase !important;
          letter-spacing: 2px !important;
          color: #000000 !important;
          padding: 8px 16px !important;
          border: 3px solid transparent;
          transition: all 0.1s;
          text-decoration: none !important;
        }
        .brutal-nav-link:hover {
          background: #FFFF00 !important;
          border-color: #000000;
          color: #000000 !important;
          transform: translate(2px, 2px);
        }
        .brutal-nav-link-danger {
          color: #FF0000 !important;
        }
        .brutal-nav-link-danger:hover {
          background: #FF0000 !important;
          color: #FFFFFF !important;
        }
      `}</style>
    </Navbar>
  );
}
